import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Typography, LinearProgress } from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const ContactAgendaEnrich = ({ open, onClose, connections, onDone }) => {
  const [connection, setConnection] = useState(""); const [running, setRunning] = useState(false);
  const [result, setResult] = useState({ processed: 0, updated: 0 }); const active = useRef(false);
  useEffect(() => () => { active.current = false; }, []);
  const start = async () => {
    if (running || !connection) return;
    active.current = true; setRunning(true); let cursor = 0; const total = { processed: 0, updated: 0 };
    try {
      while (active.current) {
        const { data } = await api.post("/contacts/agenda/enrich", { whatsappId: Number(connection), cursor });
        total.processed += data.processed; total.updated += data.updated;
        setResult({ ...total }); cursor = data.cursor;
        if (!data.hasMore) break;
      }
      onDone();
    } catch (error) { toastError(error); }
    finally { active.current = false; setRunning(false); }
  };
  return <Dialog open={open} onClose={() => { if (!running) onClose(); }} fullWidth maxWidth="sm">
    <DialogTitle>Atualizar identificação</DialogTitle>
    <DialogContent>
      <TextField select fullWidth variant="outlined" margin="dense" label="Conexão" value={connection} disabled={running} onChange={event => { setConnection(event.target.value); setResult({ processed: 0, updated: 0 }); }}>
        {connections.map(item => <MenuItem key={item.id} value={item.id} disabled={item.status !== "CONNECTED"}>{item.name}</MenuItem>)}
      </TextField>
      <Typography variant="body2" style={{ marginTop: 16 }}>{result.processed} analisados; {result.updated} atualizados.</Typography>
      {running && <LinearProgress style={{ marginTop: 12 }} />}
    </DialogContent>
    <DialogActions>{running ? <Button onClick={() => { active.current = false; }}>Parar</Button> : <Button onClick={onClose}>Fechar</Button>}
      <Button color="primary" variant="contained" disabled={running || !connection} onClick={start}>Atualizar</Button>
    </DialogActions>
  </Dialog>;
};
export default ContactAgendaEnrich;
